import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { pt_BR } from '../../lang/pt_BR';
import { header } from '../../lang/header';
import { footer } from '../../lang/footer';
import { home } from '../../lang/home';
import { catalog } from '../../lang/catalog';

i18n.use(initReactI18next).init({
  interpolation: {
    escapeValue: false
  },
  fallbackLng: 'pt-BR',
  ns: ['translation', 'header', 'footer', 'home', 'catalog'],
  defaultNS: 'translation',
  fallbackNS: 'translation',
  resources: {
    'pt-BR': {
      translation: pt_BR,
      header,
      footer,
      home,
      catalog
    }
  }
});

export default i18n;
